// coverage-calculator.js
(function () {
  const CONFIG = {
    resin: {
      standardVid: 'gid://shopify/ProductVariant/48667583447331',
      mtVid: 'gid://shopify/ProductVariant/48667583316259'
    },
    mesh: {
      roll40Vid: 'gid://shopify/ProductVariant/53281808941443',
      roll130Vid: 'gid://shopify/ProductVariant/47948814614819'
    },
    vubamacVid: 'gid://shopify/ProductVariant/56742448595331',
    macmixVid: 'gid://shopify/ProductVariant/56742485787011',

    //VubaMac Resin variant (replace with your actual variant GID)
    vubamacResinVid: 'gid://shopify/ProductVariant/47672392909091',

    bindingQuartzVid: 'gid://shopify/ProductVariant/47537887281443',
    BQ_PER_BAG: 1,
    wastageAddsToTotal: true,

    continuationVid: 'gid://shopify/ProductVariant/53262340686211',
    catalystVid: 'gid://shopify/ProductVariant/7674308624486'

  };

  // Manual image fallbacks (kept from your working version)
  const MANUAL_IMAGES = {
    'gid://shopify/ProductVariant/48667583447331': 'https://www.vubasurfaces.co.uk/cdn/shop/files/Front_Central_1_4.png?v=1760023746&width=200',
    'gid://shopify/ProductVariant/48667583316259': 'https://www.vubasurfaces.co.uk/cdn/shop/files/Front_Central_1_4.png?v=1760023746&width=200',
    'gid://shopify/ProductVariant/56742448595331': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/VubaMacBaseAggregate_2_-01.png?v=1759997766&width=200',
    'gid://shopify/ProductVariant/56742485787011': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/VubaMacBaseAggregatexMacMix-01.png?v=1759322749&width=200',
    'gid://shopify/ProductVariant/47537887281443': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/IMG_0483.png?v=1750681202&width=200',
    'gid://shopify/ProductVariant/53281808941443': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/mesh.png?v=1744906277&width=200',
    'gid://shopify/ProductVariant/47948814614819': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/mesh.png?v=1744906277&width=200',
    'gid://shopify/ProductVariant/47672392909091': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/VubaMacTop.png?v=1750099128&width=200',
    'gid://shopify/ProductVariant/53262340686211': 'https://cdn.shopify.com/s/files/1/0759/2978/0515/files/Vuba_Surface_Logo_png_no_back-01_cc79f553-0d55-4313-a38e-8035fcc67c12.webp?v=1763552163&width=200'
  };

  const PLACEHOLDER_DATA_URI =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128">
      <rect width="100%" height="100%" fill="#f4f4f5"/>
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#a1a1aa" font-family="system-ui" font-size="12">No image</text>
    </svg>`);

  const sf = () => window.ShopifyStorefront || {};
  const VARIANTS = () => (window.VUBA_VARIANTS = window.VUBA_VARIANTS || {});
  const COLORS = () => (window.VUBA_PRODUCTS = window.VUBA_PRODUCTS || {});

  // ---------- Utils ----------
  function number(x) { return parseFloat(x || '0') || 0; }
  function selectedVal(form, nameStartsWith) {
    const el = form.querySelector(`input[type="radio"][name^="${nameStartsWith}"]:checked`);
    return el ? el.value : null;
  }
  function gidToNumeric(id) {
    if (!id) return null;
    const parts = String(id).split('/');
    return parts[parts.length - 1] || null;
  }

  function ensureMount(resultsBox) {
    let mount = resultsBox.querySelector('.coverage-calculator__product-list');
    if (!mount) {
      mount = document.createElement('div');
      mount.className = 'coverage-calculator__product-list grid gap-3';
      const cta = resultsBox.querySelector('#calculator-add-to-cart');
      (cta ? cta.before(mount) : resultsBox.appendChild(mount));
    }
    return mount;
  }
  function ensureErrorBox(resultsBox) {
    let err = resultsBox.querySelector('.cc-errors');
    if (!err) {
      err = document.createElement('div');
      err.className = 'cc-errors text-red-600 text-sm mb-2';
      err.setAttribute('role', 'alert');
      err.setAttribute('aria-live', 'assertive');
      const cta = resultsBox.querySelector('#calculator-add-to-cart');
      (cta ? cta.before(err) : resultsBox.appendChild(err));
    }
    return err;
  }
  function clearErrors(resultsBox) {
    const err = ensureErrorBox(resultsBox);
    err.textContent = '';
    err.style.display = 'none';
  }
  function showError(resultsBox, msg) {
    const err = ensureErrorBox(resultsBox);
    err.textContent = msg;
    err.style.display = '';
  }

  function selectedRadioLabel(form, nameStartsWith) {
    const el = form.querySelector(`input[type="radio"][name^="${nameStartsWith}"]:checked`);
    if (!el) return null;
    const lab = form.querySelector(`label[for="${el.id}"]`);
    return lab ? lab.textContent.trim() : null;
  }

  // ---------- Storefront fetch (hybrid: GraphQL -> AJAX fallback) ----------
  async function fetchVariantById(variantId) {
    if (!variantId) return null;
    const cache = VARIANTS();
    const cached = cache[variantId];
    const hasPriceField = cached && Object.prototype.hasOwnProperty.call(cached, 'priceAmount');
    const hasAnyImage = cached && (cached.imageUrl || cached.productImageUrl);
    if (hasPriceField && hasAnyImage) return cached;
    // Helper: format from GraphQL node
    const fromGraphQL = (v) => {
      if (!v) return null;
      // Handle both modern (price) and legacy (priceV2)
      const priceNode = v.price || v.priceV2;
      const compareAtNode = v.compareAtPrice || v.compareAtPriceV2;

      const priceAmount = parseFloat(priceNode?.amount || '0') || 0;
      const currency = priceNode?.currencyCode || (window.Shopify?.currency?.active) || 'GBP';
      const compareAt = parseFloat(compareAtNode?.amount || '0') || 0;

      return {
        title: v.title || '',
        imageUrl: v.image?.url || '',
        imageAlt: v.image?.altText || v.title || '',
        productId: v.product?.id || '',
        productHandle: v.product?.handle || '',
        productVendor: v.product?.vendor || 'Vuba',
        productTitle: v.product?.title || '',
        productImageUrl: v.product?.featuredImage?.url || '',
        productImageAlt: v.product?.featuredImage?.altText || (v.product?.title || ''),
        priceAmount,
        currency,
        compareAtAmount: compareAt
      };
    };

    // Helper: AJAX fallback (/variants/{id}.js)
    const fromAjax = async (vid) => {
      try {
        const numeric = gidToNumeric(vid);
        if (!numeric) return null;
        const res = await fetch(`/variants/${numeric}.js`, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return null;
        const j = await res.json();
        const priceAmount = (j?.price || 0) / 100;             // cents -> money
        const compareAmount = (j?.compare_at_price || 0) / 100;
        const currency = (window.Shopify?.currency?.active) || 'GBP';
        // featured_image can be { src, alt }, sometimes null
        const imgSrc = j?.featured_image?.src || '';
        const imgAlt = j?.featured_image?.alt || j?.name || j?.title || 'Product';

        return {
          title: j?.title || '',
          imageUrl: imgSrc,
          imageAlt: imgAlt,
          productId: j?.product_id ? `gid://shopify/Product/${j.product_id}` : '',
          productHandle: j?.handle || '',
          productVendor: 'Vuba',
          productTitle: j?.name || j?.title || '',
          productImageUrl: imgSrc,
          productImageAlt: imgAlt,
          priceAmount,
          currency,
          compareAtAmount: compareAmount
        };
      } catch {
        return null;
      }
    };

    // 1) Try GraphQL
    try {
      const { endpoint, token } = sf();
      if (endpoint && token) {
        const query = `
        query($id: ID!) {
          node(id: $id) {
            ... on ProductVariant {
              id
              title
              price     { amount currencyCode }
              image { url(transform:{ maxWidth:300, preferredContentType: WEBP }) altText }
              product {
                id
                handle
                title
                vendor
                featuredImage { url(transform:{ maxWidth:300, preferredContentType: WEBP }) altText }
              }
            }
          }
        }`;
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
          body: JSON.stringify({ query, variables: { id: variantId } })
        });
        if (res.ok) {
          const json = await res.json();
          const datum = fromGraphQL(json?.data?.node);
          if (datum && (datum.priceAmount > 0 || datum.imageUrl || datum.productImageUrl)) {
            if (!datum.imageUrl && !datum.productImageUrl) {
              const manual = MANUAL_IMAGES[variantId];
              if (manual) {
                datum.imageUrl = manual;
                datum.imageAlt = datum.imageAlt || datum.title || 'Product';
              }
            }
            cache[variantId] = datum;
            return datum;
          }
        }
      }
    } catch { /* fall through to AJAX */ }

    // 2) AJAX fallback
    const ajaxDatum = await fromAjax(variantId);
    if (ajaxDatum) {
      if (!ajaxDatum.imageUrl && !ajaxDatum.productImageUrl) {
        const manual = MANUAL_IMAGES[variantId];
        if (manual) {
          ajaxDatum.imageUrl = manual;
          ajaxDatum.imageAlt = ajaxDatum.imageAlt || ajaxDatum.title || 'Product';
        }
      }
      cache[variantId] = ajaxDatum;
      return ajaxDatum;
    }

    return null;
  }

  // ---------- Calculator state (shared) ----------
  function computeState(formEl) {
    const areaInput = formEl.querySelector('input[type="number"][id^="ref-"]');
    const colorSelect = formEl.querySelector('select[id^="color-"]');
    const meshOptOutEl = formEl.querySelector('input[type="checkbox"][data-role="mesh-optout"]');
    const continuationCheckbox = formEl.querySelector('input[type="checkbox"][data-role="continuation-checkbox"]');
    const continuationInput = formEl.querySelector('[data-role="continuation-input"]');
    const continuationUnknown = formEl.querySelector('input[type="checkbox"][data-role="continuation-unknown"]');

    const areaInputValue = number(areaInput?.value);
    const unit = selectedVal(formEl, 'unit-') || 'sqft';

    // sqft → m² conversion
    const areaRaw = unit === 'sqft'
      ? areaInputValue / 10.7639
      : areaInputValue;
    const depth = number(selectedVal(formEl, 'depth-'));       // 4 (15mm) | 3.5 (18mm) | 3.15 (20mm)
    const wastePc = number(selectedVal(formEl, 'overage-')) / 100;
    // const resin = selectedVal(formEl, 'resin-');               // "standard" | "mt"
    const resin = 'mt';
    const vmode = selectedVal(formEl, 'vubamac-');             // "no" | "vubamac" | "vubamac-macmix"
    const noMesh = !!(meshOptOutEl && meshOptOutEl.checked);
    const catalyst = selectedVal(formEl, 'catalyst-') || 'no';
    const vubavert = selectedVal(formEl, 'vubavert-') || 'no'; // Is line ko wapas layein

    const vubavertAreaInput = formEl.querySelector('[id^="vubavert-area-"]');
    const vubavertAreaRaw = number(vubavertAreaInput?.value);
    const vubavertArea = unit === 'sqft' ? vubavertAreaRaw / 10.7639 : vubavertAreaRaw;

    const vubavertColorSelect = formEl.querySelector('[id^="vubavert-color-"]');

    const area = CONFIG.wastageAddsToTotal ? areaRaw * (1 + wastePc) : areaRaw;

    // --- Default "bags" logic (for colour/resin/BQ) ---
    let bags = 0;
    if (area > 0 && depth > 0) {
      const areaInSqft = area * 10.7639;
      bags = Math.ceil(areaInSqft / depth);
    }

    // ---VubaMac / VubaMac & MacMix quantities, depth-specific divisors ---
    let vmQty = 0;
    if (area > 0 && (vmode === 'vubamac' || vmode === 'vubamac-macmix')) {
      // Divisors by depth:
      // 15mm (4):    VubaMac = 4.5   | VubaMac & MacMix = 5
      // 18mm (3.5):  VubaMac = 2.3   | VubaMac & MacMix = 2.6
      // 20mm (3.15): VubaMac = 1.9   | VubaMac & MacMix = 2.15
      let divisor = 0;
      if (depth === 68) { // 3/8"
        divisor = (vmode === 'vubamac') ? 4.5 : 5;
      } else if (depth === 43) { // 5/8"
        divisor = (vmode === 'vubamac') ? 2.3 : 2.6;
      } else if (depth === 38) { // 3/4"
        divisor = (vmode === 'vubamac') ? 1.9 : 2.15;
      }
      if (divisor > 0) vmQty = Math.ceil(area / divisor);
    }

    // colour variant id from inline loader cache
    const colorHandle = colorSelect?.value || '';
    const colorDatum = colorHandle ? COLORS()[colorHandle] : null;
    const colorVid = colorDatum?.variantId || null;
    const colorKit = {
      bag1: colorDatum?.kitItem1 || '',
      bag2: colorDatum?.kitItem2 || '',
      bag3: colorDatum?.kitItem3 || '',
      bag4: colorDatum?.kitItem4 || ''
    };

    // --- Mesh calculation ---
    const forceMesh = (vmode === 'vubamac' || vmode === 'vubamac-macmix');
    let meshQty = 0, meshVid = null;

    if (area > 0 && (forceMesh || !noMesh)) {
      meshVid = CONFIG.mesh.roll130Vid || null;

      // If VubaMac / VubaMac & MacMix at 18mm or 20mm, treat as 2 layers of mesh
      const layers = (forceMesh && (depth === 43 || depth === 38)) ? 2 : 1;

      // IMPORTANT: multiply before ceil to avoid over-counting
      meshQty = Math.ceil((area * layers) / 130);
    }

    const resinVid = (resin === 'standard') ? CONFIG.resin.standardVid : (resin === 'mt') ? CONFIG.resin.mtVid : null;
    const vmVid = (vmode === 'vubamac') ? CONFIG.vubamacVid : (vmode === 'vubamac-macmix') ? CONFIG.macmixVid : null;
    const bqVid = CONFIG.bindingQuartzVid || null;

    return {
      // Core inputs
      area: areaRaw,
      areaWithWaste: area,
      depth, wastePc, vmode,
      bags,
      vmQty,

      // Colour
      colorVid, colorHandle, colorDatum, colorKit,

      // Variants
      resinVid, vmVid, bqVid, meshQty, meshVid,

      // Catalyst
      catalyst,
      catalystQty: (() => {
        if (catalyst !== 'yes') return 0;
        let totalBags = bags;
        const addRows = Array.from(formEl.querySelectorAll('.additional-color-row'));
        addRows.forEach(row => {
          const rArea = number(row.querySelector('.row-area')?.value);
          const rDepth = number(row.querySelector('.row-depth')?.value);
          if (rArea > 0 && rDepth > 0) {
            totalBags += Math.ceil((unit === 'sqft' ? rArea / 10.7639 : rArea) * 10.7639 / rDepth);
          }
        });
        return Math.ceil(totalBags / 24);
      })(),

      // VubaVert (Yes/No status + Area + Color)
      vubavert,
      vubavertArea: vubavertArea,
      vubavertColorHandle: vubavertColorSelect?.value || '',
      vubavertColorVid: vubavertColorSelect?.value ? window.VUBA_PRODUCTS[vubavertColorSelect.value]?.variantId : null,
      vubavertColorTitle: vubavertColorSelect?.value ? window.VUBA_PRODUCTS[vubavertColorSelect.value]?.title : null,

      // Multiple Color Sections
      additionalSections: (selectedVal(formEl, 'multi-color-toggle-') === 'yes') ? Array.from(formEl.querySelectorAll('.additional-color-row')).map(row => {
        const rowAreaRaw = number(row.querySelector('.row-area')?.value);
        const rowDepth = number(row.querySelector('.row-depth')?.value);
        const rowColorHandle = row.querySelector('select[id^="select-"]')?.value;

        return {
          area: unit === 'sqft' ? rowAreaRaw / 10.7639 : rowAreaRaw,
          depth: rowDepth,
          colorVid: rowColorHandle ? window.VUBA_PRODUCTS[rowColorHandle]?.variantId : null,
          colorTitle: rowColorHandle ? window.VUBA_PRODUCTS[rowColorHandle]?.title : 'Additional Color'
        };
      }) : [],

      continuationEnabled: !!(continuationCheckbox && continuationCheckbox.checked),
      continuationOrderNumber: continuationUnknown && continuationUnknown.checked
        ? 'Unknown'
        : (continuationInput && continuationInput.value ? continuationInput.value.trim() : '')
    };
  }

  function formatMoney(amount, currency) {
    try {
      const code = currency || (window.Shopify?.currency?.active) || 'GBP';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount || 0);
    } catch {
      return `£${(amount || 0).toFixed(2)}`;
    }
  }

  function setLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      btn.dataset.prevText = btn.textContent;
      btn.disabled = true;
      btn.classList.add('opacity-70', 'cursor-wait');
      btn.innerHTML = `
      <span class="inline-flex items-center gap-2 justify-center w-full">
        <span class="cc-spinner" aria-hidden="true"></span>
        Adding…
      </span>`;
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.disabled = false;
      btn.classList.remove('opacity-70', 'cursor-wait');
      btn.textContent = btn.dataset.prevText || 'Add To Cart';
      btn.removeAttribute('aria-busy');
    }
  }


  // ---------- Build cart lines from state ----------
  function collectCartLines(state) {
    const lines = [];

    if (state.bags > 0 && state.colorVid) {
      lines.push({ id: state.colorVid, quantity: state.bags });
    }
    if (state.bags > 0 && state.resinVid) {
      lines.push({ id: state.resinVid, quantity: state.bags });
    }
    if (state.vmQty > 0 && state.vmVid) {
      lines.push({ id: state.vmVid, quantity: state.vmQty });
    }

    // VubaMac Resin
    if (state.vmQty > 0 && CONFIG.vubamacResinVid) {
      lines.push({ id: CONFIG.vubamacResinVid, quantity: state.vmQty });
    }

    // if (state.bags > 0 && state.bqVid) {
    //   const qty = CONFIG.BQ_PER_BAG > 0 ? state.bags * CONFIG.BQ_PER_BAG : state.bags;
    //   lines.push({ id: state.bqVid, quantity: qty });
    // }
    if (state.bags > 0 && state.bqVid && state.vmode === 'no') {
      const qty = CONFIG.BQ_PER_BAG > 0 ? state.bags * CONFIG.BQ_PER_BAG : state.bags;
      lines.push({ id: state.bqVid, quantity: qty });
    }
    if (state.meshQty > 0 && state.meshVid) {
      lines.push({ id: state.meshVid, quantity: state.meshQty });
    }

    if (state.continuationEnabled && CONFIG.continuationVid) {
      lines.push({ id: CONFIG.continuationVid, quantity: 1 });
    }
    if (state.catalyst === 'yes' && state.catalystQty > 0 && CONFIG.catalystVid) {
      lines.push({ id: CONFIG.catalystVid, quantity: state.catalystQty });
    }
    // VubaVert
    if (state.vubavert === 'yes' && state.vubavertArea > 0) {
      const vid = state.vubavertColorVid || state.colorVid;
      if (vid) {
        lines.push({ id: vid, quantity: Math.ceil(state.vubavertArea * 10.7639 / 20) });
      }
    }

    // Additional Color Sections (Borders)
    if (state.additionalSections && state.additionalSections.length > 0) {
      state.additionalSections.forEach(section => {
        if (section.area > 0 && section.colorVid) {
          const sectionBags = Math.ceil(section.area * 10.7639 / section.depth);

          // Border Stone
          lines.push({ id: section.colorVid, quantity: sectionBags });

          // Border Resin
          if (state.resinVid) {
            lines.push({ id: state.resinVid, quantity: sectionBags });
          }

          // Border Binding Quartz
          if (state.bqVid) {
            const qty = CONFIG.BQ_PER_BAG > 0 ? sectionBags * CONFIG.BQ_PER_BAG : sectionBags;
            lines.push({ id: state.bqVid, quantity: qty });
          }
        }
      });
    }

    // merge any duplicates (same variant twice)
    const merged = {};
    lines.forEach(l => {
      merged[l.id] = (merged[l.id] || 0) + l.quantity;
    });

    return Object.entries(merged).map(([id, quantity]) => ({ id, quantity }));
  }

  // ---------- Renderer ----------
  function renderCard({ imageUrl, imageAlt, title, qty, unitPrice, currency }) {
    const wrap = document.createElement('div');
    wrap.className = 'cc-card flex items-center gap-3 p-3 rounded-xl border border-gray-200';
    const safeUrl = imageUrl || PLACEHOLDER_DATA_URI;
    const safeAlt = escapeHtml(imageAlt || title || 'Product');

    const showPrice = typeof unitPrice === 'number' && unitPrice > 0;
    const lineTotal = showPrice ? unitPrice * qty : 0;
    const priceHtml = showPrice
      ? `<div class="text-sm text-gray-600">${formatMoney(unitPrice, currency)} × ${qty} = <span class="font-semibold">${formatMoney(lineTotal, currency)}</span></div>`
      : `<div class="text-sm text-gray-500">Price unavailable</div>`;

    wrap.innerHTML = `
    <div class="cc-card__img w-16 h-16 rounded-lg overflow-hidden bg-gray-50 flex-shrink-0">
      <img src="${safeUrl}" alt="${safeAlt}" class="w-full h-full object-cover" loading="lazy">
    </div>
    <div class="cc-card__meta flex-1">
      <div class="font-medium leading-tight">${escapeHtml(title)}</div>
    </div>
    <div class="cc-card__qty text-right font-semibold">× ${qty}</div>
  `;
    return wrap;
  }
  function escapeHtml(s = '') {
    return s.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  async function pushVariantOrFallback(items, variantId, qty, fallbackTitle, opts = {}) {
    if (!(qty > 0)) return;

    const manualUrl = opts.manualUrl || MANUAL_IMAGES[variantId] || null;
    const forcedTitle = opts.forcedTitle || null;
    const altImageUrl = opts.altImageUrl || null;

    const baseItem = (title) => ({
      title,
      imageUrl: altImageUrl || manualUrl || PLACEHOLDER_DATA_URI,
      imageAlt: title,
      qty,
      unitPrice: 0,
      currency: (window.Shopify?.currency?.active) || 'GBP'
    });

    if (!variantId) {
      items.push(baseItem(forcedTitle || fallbackTitle));
      return;
    }

    const v = await fetchVariantById(variantId);

    if (v) {
      const computedTitle = (() => {
        const pt = (v.productTitle || '').trim();
        const vt = (v.title || '').trim();
        const vtIsDefault = /^default\s*title$/i.test(vt);
        if (!vt || vtIsDefault) return pt || fallbackTitle;
        if (pt.toLowerCase().includes(vt.toLowerCase())) return pt;
        return `${pt}${pt && vt ? ' — ' : ''}${vt}`;
      })();

      const titleOut = forcedTitle || computedTitle || fallbackTitle;

      const finalUrl = v.imageUrl
        || v.productImageUrl
        || altImageUrl
        || manualUrl
        || PLACEHOLDER_DATA_URI;

      const finalAlt = v.imageAlt || v.productImageAlt || titleOut;

      // override priceAmount with contextual (Liquid) price if available
      const numericId = gidToNumeric(variantId);
      const contextualMap = window.VUBA_CONTEXTUAL_PRICES || {};
      const contextualPrice = numericId ? contextualMap[numericId] : null;

      const unitPrice = (contextualPrice != null && !Number.isNaN(Number(contextualPrice)))
        ? Number(contextualPrice)
        : (v.priceAmount || 0);

      items.push({
        title: titleOut,
        imageUrl: finalUrl,
        imageAlt: finalAlt,
        qty,
        unitPrice,
        productId: v.productId,        // Save Product GID
        variantId: variantId,          // Save Variant GID
        productHandle: v.productHandle || 'product-handle',
        productVendor: v.productVendor || 'Vuba',
        currency: v.currency || (window.Shopify?.currency?.active) || 'GBP'
      });
    } else {
      const item = baseItem(forcedTitle || fallbackTitle);
      item.variantId = variantId;
      if (opts.productId) item.productId = opts.productId;
      items.push(item);
    }
  }

  async function buildAndRender(formEl) {
    const resultsBox = formEl.querySelector('.coverage-calculator__form--results');
    if (!resultsBox) return;
    clearErrors(resultsBox);

    const mount = ensureMount(resultsBox);
    showLoading(mount);

    const state = computeState(formEl);
    const items = [];

    // Colour
    if (state.colorVid && state.bags > 0) {
      await pushVariantOrFallback(
        items,
        state.colorVid,
        state.bags,
        state.colorDatum?.title || 'Colour',
        {
          altImageUrl:
            state.colorDatum?.image?.src ||
            state.colorDatum?.imageUrl ||
            state.colorDatum?.image ||
            null
        }
      );
    }

    // Resin
    if (state.bags > 0 && state.resinVid) {
      const choiceLabel = selectedRadioLabel(formEl, 'resin-') || (state.resinVid === CONFIG.resin.mtVid ? 'MT' : 'Standard');
      await pushVariantOrFallback(
        items,
        state.resinVid,
        state.bags,
        `Resin — ${choiceLabel}`,
        { forcedTitle: `Resin — ${choiceLabel}` }
      );
    }

    // VubaMac / MacMix
    if (state.vmQty > 0 && state.vmVid) {
      const forced = (state.vmode === 'vubamac-macmix') ? 'VubaMac & MacMix' : 'VubaMac Base';
      await pushVariantOrFallback(items, state.vmVid, state.vmQty, forced, { forcedTitle: forced });

      //  VubaMac Resin line 
      if (CONFIG.vubamacResinVid) {
        await pushVariantOrFallback(
          items,
          CONFIG.vubamacResinVid,
          state.vmQty,
          'VubaMac Resin',
          { forcedTitle: 'VubaMac Resin' }
        );
      } else {
        await pushVariantOrFallback(items, null, state.vmQty, 'VubaMac Resin', { forcedTitle: 'VubaMac Resin' });
      }
    }

    // Binding Quartz
    // if (state.bags > 0 && state.bqVid) {
    //   await pushVariantOrFallback(items, state.bqVid, state.bags * CONFIG.BQ_PER_BAG, 'Binding Quartz');
    // }
    if (state.bags > 0 && state.bqVid && state.vmode === 'no') {
      await pushVariantOrFallback(items, state.bqVid, state.bags * CONFIG.BQ_PER_BAG, 'Binding Quartz');
    }

    // Mesh
    if (state.meshQty > 0 && state.meshVid) {
      const label = 'Mesh — 130m²';
      await pushVariantOrFallback(items, state.meshVid, state.meshQty, label);
    }

    if (state.catalyst === 'yes') {
      await pushVariantOrFallback(
        items,
        CONFIG.catalystVid,
        state.catalystQty,
        'Catalyst Box (1 Box per 24 Kits)',
        {
          forcedTitle: 'Catalyst Box (1 Box per 24 Kits)',
          manualUrl: 'https://cdn.shopify.com/s/files/1/0628/7520/5734/files/200mlCatalyst.webp?v=1750666935',
          productId: 'gid://shopify/Product/7674308624486'
        }
      );
    }

    // VubaVert Quantitative
    if (state.vubavert === 'yes' && state.vubavertArea > 0) {
      const vertColorName = state.vubavertColorTitle || state.colorDatum?.title || 'Selected Color';
      await pushVariantOrFallback(
        items,
        state.vubavertColorVid || state.colorVid,
        Math.ceil(state.vubavertArea * 10.7639 / 20),
        `VubaVert — ${vertColorName}`,
        {
          forcedTitle: `VubaVert — ${vertColorName}`,
          manualUrl: 'https://cdn.shopify.com/s/files/1/0628/7520/5734/files/VubaVert.webp?v=1760603684'
        }
      );
    }

    // Additional Color Sections Loop
    if (state.additionalSections && state.additionalSections.length > 0) {
      for (const section of state.additionalSections) {
        if (section.area > 0 && section.colorVid) {
          const sectionBags = Math.ceil(section.area * 10.7639 / section.depth);

          // 1. Stone (Colour)
          await pushVariantOrFallback(
            items,
            section.colorVid,
            sectionBags,
            `Border: ${section.colorTitle}`,
            { forcedTitle: `Border: ${section.colorTitle}` }
          );

          // 2. Resin (Always included for border)
          if (state.resinVid) {
            const resinLabel = (state.resinVid === CONFIG.resin.mtVid ? 'MT' : 'Standard');
            await pushVariantOrFallback(
              items,
              state.resinVid,
              sectionBags,
              `Resin — ${resinLabel} (Border)`,
              { forcedTitle: `Resin — ${resinLabel} (Border)` }
            );
          }

          // 3. Binding Quartz (Always included for border)
          if (state.bqVid) {
            await pushVariantOrFallback(
              items,
              state.bqVid,
              sectionBags * CONFIG.BQ_PER_BAG,
              'Binding Quartz (Border)',
              { forcedTitle: 'Binding Quartz (Border)' }
            );
          }
        }
      }
    }

    if (state.continuationEnabled && CONFIG.continuationVid) {
      await pushVariantOrFallback(
        items,
        CONFIG.continuationVid,
        1,
        'Continuation order',        // fallback title
        { forcedTitle: 'Continuation order' }
      );
    }
    mount.innerHTML = ''; // clear loader

    if (items.length === 0) {
      mount.innerHTML = `<div class="text-gray-500">No products to display yet.</div>`;
      return;
    }

    // Render cards
    // Clear mount first
    mount.innerHTML = '';

    // Create 'Vuba Topping' Group Container
    const toppingGroup = document.createElement('div');
    toppingGroup.className = 'cc-topping-group border rounded-2xl p-4 bg-gray-50/50 mb-4';
    toppingGroup.innerHTML = `<h3 class="font-bold text-vuba-red mb-3 uppercase text-xs tracking-wider">Vuba Topping</h3>`;
    const toppingList = document.createElement('div');
    toppingList.className = 'space-y-3';
    toppingGroup.appendChild(toppingList);

    // Filter Topping items (Resin, Quartz, Aggregate)
    const toppingItems = items.filter(i =>
      i.title.toLowerCase().includes('resin') ||
      i.title.toLowerCase().includes('quartz') ||
      i.title.toLowerCase().includes(state.colorDatum?.title.toLowerCase())
    );

    const otherItems = items.filter(i => !toppingItems.includes(i));

    // Special Grouping for Resin & Quartz
    const resinItem = toppingItems.find(i => i.title.toLowerCase().includes('resin'));
    const quartzItem = toppingItems.find(i => i.title.toLowerCase().includes('quartz'));
    const aggregateItem = toppingItems.find(i => state.colorDatum && i.title.toLowerCase().includes(state.colorDatum.title.toLowerCase()));

    // Resin & Quartz Kit Card (Side by Side Pictures)
    if (resinItem || quartzItem) {
      const kitWrap = document.createElement('div');
      kitWrap.className = 'cc-kit-card p-3 bg-white rounded-xl border border-gray-100 shadow-sm';
      const qty = resinItem ? resinItem.qty : (quartzItem ? quartzItem.qty : 0);

      kitWrap.innerHTML = `
        <div class="flex items-center gap-3">
            <div class="flex items-center gap-4">
              <img src="${resinItem?.imageUrl || PLACEHOLDER_DATA_URI}" class="kit-img-large rounded-xl border border-gray-100 object-cover shadow-sm">
              <img src="${quartzItem?.imageUrl || PLACEHOLDER_DATA_URI}" class="kit-img-large rounded-xl border border-gray-100 object-cover shadow-sm">
          </div>
            <div class="flex-1">
                <div class="font-bold text-sm">Resin & Quartz Kit</div>
                <div class="text-xs text-gray-500 italic">Pre-Catalysed Resin + Binding Quartz</div>
            </div>
            <div class="font-bold">× ${qty}</div>
        </div>
    `;
      toppingList.appendChild(kitWrap);
    }

    // Aggregate Card Underneath
    if (aggregateItem) {
      const aggWrap = document.createElement('div');
      aggWrap.className = 'cc-agg-card p-3 bg-white rounded-xl border border-gray-100 shadow-sm mt-2';
      aggWrap.innerHTML = `
        <div class="flex items-center gap-3">
            <img src="${aggregateItem.imageUrl}" class="w-12 h-12 rounded-lg object-cover">
            <div class="flex-1">
                <div class="font-bold text-sm">${aggregateItem.qty} x ${state.colorDatum.title}</div>
            </div>
        </div>
    `;
      toppingList.appendChild(aggWrap);
    }

    mount.appendChild(toppingGroup);

    if (otherItems.length > 0) {
      const essentialsGroup = document.createElement('div');
      essentialsGroup.className = 'cc-topping-group border rounded-2xl p-4 bg-gray-50/50 mb-4';
      essentialsGroup.innerHTML = `<h3 class="font-bold text-vuba-red mb-3 uppercase text-xs tracking-wider">Project Essentials</h3>`;
      const essentialsList = document.createElement('div');
      essentialsList.className = 'space-y-3';
      essentialsGroup.appendChild(essentialsList);
      otherItems.forEach(item => {
        const card = renderCard(item);
        // Add specific class for premium look within essentials
        card.className = 'cc-agg-card p-3 bg-white rounded-xl border border-gray-100 shadow-sm mt-2 flex items-center gap-3';
        essentialsList.appendChild(card);
      });
      mount.appendChild(essentialsGroup);
    }

    // --- Quote App Integration ---
    // --- Quote App Integration (Multi-Product Support) ---
    const rfqBtn = document.getElementById('rfq-button');
    if (rfqBtn && items.length > 0) {
      window.GRFQConfigs = window.GRFQConfigs || {};
      window.GRFQConfigs.products = window.GRFQConfigs.products || [];

      // Loop through all calculated items to prepare Globo Config
      const quoteProducts = items.map(it => {
        const prodNumericId = gidToNumeric(it.productId);
        const varNumericId = gidToNumeric(it.variantId);

        if (!prodNumericId) return null;

        const dummyProduct = {
          id: prodNumericId,
          title: it.title,
          handle: it.productHandle,
          vendor: it.productVendor,
          price: it.unitPrice || 0,
          variants: [{
            id: varNumericId,
            title: 'Default Title',
            price: it.unitPrice || 0
          }],
          images: [it.imageUrl || ''],
          featured_image: it.imageUrl || ''
        };

        // Update global config array
        window.GRFQConfigs.products = window.GRFQConfigs.products.filter(p => String(p.id) !== String(prodNumericId));
        window.GRFQConfigs.products.push(dummyProduct);

        return { prodNumericId, varNumericId, qty: it.qty };
      }).filter(p => p !== null);

      if (quoteProducts.length > 0) {
        rfqBtn.style.display = 'block';
        rfqBtn.innerText = 'Add to Quote';

        // Override the onclick with a bulk add loop
        rfqBtn.onclick = async (e) => {
          e.stopPropagation();

          for (let i = 0; i < quoteProducts.length; i++) {
            const p = quoteProducts[i];
            const isLast = (i === quoteProducts.length - 1);

            if (isLast) {
              // For the last item, we update the main button attributes
              // so Globo uses it to trigger the final UI/Modal
              rfqBtn.setAttribute('data-variant-id', p.varNumericId);
              rfqBtn.setAttribute('data-quantity', p.qty);

              if (window.GRFQApp && typeof GRFQApp.addProduct === 'function') {
                GRFQApp.addProduct(rfqBtn, p.prodNumericId);
              }
            } else {
              // For other items, we use a hidden link/button and small delay
              const silentBtn = document.createElement('button');
              silentBtn.setAttribute('data-variant-id', p.varNumericId);
              silentBtn.setAttribute('data-quantity', p.qty);

              if (window.GRFQApp && typeof GRFQApp.addProduct === 'function') {
                GRFQApp.addProduct(silentBtn, p.prodNumericId);
              }
              // Small delay to let Globo's internal state update
              await new Promise(r => setTimeout(r, 400));
            }
          }
        };
      } else {
        rfqBtn.style.display = 'none';
      }
    } else if (rfqBtn) {
      rfqBtn.style.display = 'none';
    }

    // Render grand total (sum only items with a known price)
    // const firstCurrency = items.find(i => typeof i.unitPrice === 'number' && i.unitPrice > 0)?.currency || (window.Shopify?.currency?.active) || 'GBP';
    // const grandTotal = items.reduce((sum, i) => sum + ((i.unitPrice || 0) * (i.qty || 0)), 0);
    // const totalEl = document.createElement('div');
    // totalEl.className = 'cc-total mt-2 pt-2 border-t border-gray-200 text-right font-semibold';
    // totalEl.innerHTML = `<span>Total:</span> <span class="ml-2">${formatMoney(grandTotal, firstCurrency)} + VAT</span>`;
    // mount.appendChild(totalEl);
  }


  // ---------- Add to Cart ----------
  async function addToCartFromForm(formEl, btnEl) {
    const resultsBox = formEl.querySelector('.coverage-calculator__form--results');
    clearErrors(resultsBox);

    const state = computeState(formEl);

    if (!(state.bags > 0)) {
      showError(resultsBox, 'Please enter an area and options that produce at least 1 bag.');
      return;
    }
    if (!state.colorVid) {
      showError(resultsBox, 'Please choose a colour.');
      return;
    }

    const lines = collectCartLines(state);
    if (!lines.length) {
      showError(resultsBox, 'Nothing to add. Please review your selections.');
      return;
    }

    // --- Build properties for the colour line from metafields ---
    const colorDatum = state.colorDatum || {};
    const colorKit = state.colorKit || {};

    // Prefer the kit object from computeState, fall back to raw metafields on colorDatum
    const bag1 = colorKit.bag1 || colorDatum.kitItem1 || '';
    const bag2 = colorKit.bag2 || colorDatum.kitItem2 || '';
    const bag3 = colorKit.bag3 || colorDatum.kitItem3 || '';
    const bag4 = colorKit.bag4 || colorDatum.kitItem4 || '';

    const bagProps = {
      'bag-1': String(bag1),
      'bag-2': String(bag2),
      'bag-3': String(bag3),
      'bag-4': String(bag4)
    };

    // --- Map calculator lines cart/add.js items, attaching properties only to colour line ---
    const items = lines
      .map(l => {
        const numericId = gidToNumeric(l.id);
        if (!numericId || !(l.quantity > 0)) return null;

        const isColourLine = (l.id === state.colorVid);

        const base = {
          id: numericId,
          quantity: l.quantity
        };

        if (isColourLine) {
          // Always attach properties to the colour line
          return {
            ...base,
            properties: bagProps
          };
        }

        return base;
      })
      .filter(Boolean);

    if (!items.length) {
      showError(resultsBox, 'Nothing to add. Please review your selections.');
      return;
    }

    // Debug: see exactly what we’re sending to Shopify
    console.log('[Coverage calculator] colour metafields:', {
      colorHandle: state.colorHandle,
      colorVid: state.colorVid,
      colorDatum
    });
    console.log('[Coverage calculator] cart/add.js payload:', { items });

    try {
      setLoading(btnEl, true);

      // Base payload
      const payload = { items };

      // If continuation info is present, add / merge into cart note
      if (state.continuationEnabled && state.continuationOrderNumber) {
        let noteText = `Continuation order: ${state.continuationOrderNumber}`;

        try {
          // Try to preserve any existing cart note
          const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          if (cartRes.ok) {
            const cartJson = await cartRes.json();
            const existingNote = cartJson?.note ? String(cartJson.note).trim() : '';

            if (existingNote) {
              if (!existingNote.includes(noteText)) {
                noteText = `${existingNote}\n${noteText}`;
              } else {
                // If it's already in there, just keep the existing note
                noteText = existingNote;
              }
            }
          }
        } catch (e) {
          console.warn('[Coverage calculator] unable to read existing cart note', e);
          // fall back to just the continuation note
        }

        payload.note = noteText;
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        const msg = err?.description || err?.message || 'Unable to add to cart. Please try again.';
        showError(resultsBox, msg);
        return;
      }

      window.location.href = '/cart';
    } catch (e) {
      console.error('[Coverage calculator] add to cart failed:', e);
      showError(resultsBox, 'Network error adding to cart. Please try again.');
    } finally {
      setLoading(btnEl, false);
    }
  }

  // ---------- Init & wiring ----------
  function initOneForm(formEl) {
    if (!formEl || formEl._ccCardsInit) return;
    formEl._ccCardsInit = true;

    const rerender = () => buildAndRender(formEl);

    const areaInput = formEl.querySelector('input[type="number"][id^="ref-"]');
    const colorSelect = formEl.querySelector('select[id^="color-"]');
    const meshOptOutEl = formEl.querySelector('input[type="checkbox"][data-role="mesh-optout"]');
    const ctaBtn = formEl.querySelector('#calculator-add-to-cart');
    const continuationCheckbox = formEl.querySelector('input[type="checkbox"][data-role="continuation-checkbox"]');
    const continuationWrapper = formEl.querySelector('[data-role="continuation-wrapper"]');
    const continuationInput = formEl.querySelector('[data-role="continuation-input"]');
    const updateDepthLabels = () => {
      const selectedUnit = selectedVal(formEl, 'unit-');

      // Main labels update
      const label38 = formEl.querySelector('.depth-label-38');
      const label58 = formEl.querySelector('.depth-label-58');
      const label34 = formEl.querySelector('.depth-label-34');

      if (selectedUnit === 'sqft') {
        if (label38) label38.textContent = 'Pedestrian – 3/8"';
        if (label58) label58.textContent = 'Drive On/Off Vehicles – 5/8"';
        if (label34) label34.textContent = 'Turning Vehicles – 3/4"';
      } else {
        if (label38) label38.textContent = 'Pedestrian – 10mm depth';
        if (label58) label58.textContent = 'Drive On/Off Vehicles – 15mm depth';
        if (label34) label34.textContent = 'Turning Vehicles – 18mm depth';
      }

      // Naye Border sections ke options bhi update karein
      formEl.querySelectorAll('.row-depth').forEach(sel => {
        sel.options[0].text = selectedUnit === 'sqft' ? 'Pedestrian – 3/8"' : 'Pedestrian – 10mm';
        sel.options[1].text = selectedUnit === 'sqft' ? 'Drive – 5/8"' : 'Drive – 15mm';
        sel.options[2].text = selectedUnit === 'sqft' ? 'Turning – 3/4"' : 'Turning – 18mm';
      });
    };
    // Add listener for unit change
    formEl.querySelectorAll('input[name^="unit-"]').forEach(radio => {
      radio.addEventListener('change', updateDepthLabels, { passive: true });
    });
    // Initial check
    updateDepthLabels();

    // 1. VubaVert Toggle logic
    const vubavertDetails = formEl.querySelector('[id^="vubavert-details-"]');
    const updateVubavertUI = () => {
      const isYes = selectedVal(formEl, 'vubavert-') === 'yes';
      if (vubavertDetails) vubavertDetails.style.display = isYes ? 'block' : 'none';
      rerender();
    };
    formEl.querySelectorAll('input[name^="vubavert-"]').forEach(r => r.addEventListener('change', updateVubavertUI));

    // 2. Multi-color Toggle logic
    const multiContainer = formEl.querySelector('[id^="multi-color-container-"]');
    const updateMultiColorUI = () => {
      const isYes = selectedVal(formEl, 'multi-color-toggle-') === 'yes';
      if (multiContainer) multiContainer.style.display = isYes ? 'block' : 'none';
      rerender();
    };
    formEl.querySelectorAll('input[name^="multi-color-toggle-"]').forEach(r => {
      r.addEventListener('change', updateMultiColorUI);
    });
    updateMultiColorUI(); // Initial check

    const vertColorSelect = formEl.querySelector('[id^="vubavert-color-"]');
    if (vertColorSelect) {
      // Listener for re-calc
      vertColorSelect.addEventListener('change', rerender);

      // If NOT already initialized by Liquid, we could do it here, 
      // but Liquid already handles it. We just need to make sure the listener is there.
    }

    // Main color listener (Choices.js triggers a standard change event)
    const mainColorSelect = formEl.querySelector('select[id^="color-"]');
    if (mainColorSelect) {
      mainColorSelect.addEventListener('change', rerender);
    }

    // VubaVert Area listener
    const vubavertAreaInput = formEl.querySelector('[id^="vubavert-area-"]');
    if (vubavertAreaInput) {
      vubavertAreaInput.addEventListener('input', rerender);
    }

    const continuationUnknown = formEl.querySelector('input[type="checkbox"][data-role="continuation-unknown"]');

    if (continuationUnknown && continuationInput) {
      continuationUnknown.addEventListener('change', () => {
        if (continuationUnknown.checked) {
          continuationInput.value = '';
          continuationInput.disabled = true;
          continuationInput.style.backgroundColor = '#f3f4f6';
          continuationInput.placeholder = 'Unknown';
        } else {
          continuationInput.disabled = false;
          continuationInput.style.backgroundColor = '';
          continuationInput.placeholder = 'e.g. #12345';
        }
        rerender();
      });
    }

    const addColorBtn = formEl.querySelector('[id^="add-color-btn-"]');
    const colorsList = formEl.querySelector('[id^="additional-colors-list-"]');

    if (addColorBtn && colorsList) {
      addColorBtn.addEventListener('click', () => {
        const rowId = Date.now();
        const row = document.createElement('div');
        row.className = 'additional-color-row p-3 border rounded-xl bg-white shadow-sm mb-3 relative';
        const unit = selectedVal(formEl, 'unit-') || 'sqft';
        row.innerHTML = `
          <button type="button" class="remove-row absolute -top-3 -right-3 bg-vuba-red text-white rounded-full w-8 h-8 flex items-center justify-center shadow-lg hover:scale-110 transition-transform z-10">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
          
          <div class="grid grid-cols-2 gap-4 mb-4">
            <div class="coverage-calculator__field">
              <fieldset>
                <legend>Area (${unit})</legend>
                <input type="number" class="row-area w-full" placeholder="Enter area">
              </fieldset>
            </div>
            <div class="coverage-calculator__field">
              <fieldset class="tabs" style="--tabs:1">
                <legend>Select depth</legend>
                <select class="row-depth w-full mt-1">
                  <option value="68">${unit === 'sqft' ? 'Pedestrian – 3/8"' : 'Pedestrian – 10mm'}</option>
                  <option value="43">${unit === 'sqft' ? 'Drive – 5/8"' : 'Drive – 15mm'}</option>
                  <option value="38">${unit === 'sqft' ? 'Turning – 3/4"' : 'Turning – 18mm'}</option>
                </select>
              </fieldset>
            </div>
          </div>
          
          <div class="coverage-calculator__field">
            <fieldset>
              <legend>Select a Vuba Color</legend>
              <label class="sr-only" for="select-${rowId}">Choose a color</label>
              <select
                id="select-${rowId}"
                class="row-color w-full"
                required
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
                data-gramm="false"
                data-gramm_editor="false"
                data-enable-grammarly="false"
                data-lt-active="false"
                data-microsoft-editor="false"
                autocapitalize="off"
                inputmode="search"
                data-lpignore="true"
                data-1p-ignore="true"
                data-bwignore="true"
                data-form-type="other"
              >
                <option value="" disabled selected>Loading…</option>
              </select>
            </fieldset>
          </div>
        `;
        colorsList.appendChild(row);

        // Naye select box mein colors populate karna
        const newSelect = row.querySelector(`#select-${rowId}`);
        if (window.Choices) {
          const choices = new Choices(newSelect, {
            searchEnabled: true,
            itemSelectText: '',
            callbackOnCreateTemplates: function (template) {
              return {
                choice: (classNames, data) => {
                  const product = window.VUBA_PRODUCTS[data.value];
                  const imgTag = product && product.imageUrl
                    ? `<img src="${product.imageUrl}" style="width:24px; height:24px; margin-right:8px; border-radius:4px; object-fit:cover;">`
                    : '';
                  return template(`
                    <div class="${classNames.item} ${classNames.itemChoice} ${classNames.itemSelectable}" data-select-text="" data-choice data-id="${data.id}" data-value="${data.value}" role="option">
                      <div style="display:flex; align-items:center;">
                        ${imgTag}
                        <span>${data.label}</span>
                      </div>
                    </div>
                  `);
                },
              };
            }
          });
          const items = Object.entries(window.VUBA_PRODUCTS).map(([val, data]) => ({ value: val, label: data.title }));
          choices.setChoices(items, 'value', 'label', true);
          newSelect.addEventListener('change', rerender);
        }

        row.querySelector('.row-area').addEventListener('input', rerender);
        row.querySelector('.row-depth').addEventListener('change', rerender);
        row.querySelector('.remove-row').onclick = () => { row.remove(); rerender(); };

        rerender();
      });
    }

    // Catalyst warning toggle
    const updateCatalystWarning = () => {
      const val = selectedVal(formEl, 'catalyst-');
      const warning = formEl.querySelector('.catalyst-warning-message');
      if (warning) warning.style.display = (val === 'no') ? 'block' : 'none';
    };

    formEl.querySelectorAll('input[name^="catalyst-"]').forEach(r => {
      r.addEventListener('change', updateCatalystWarning);
    });
    updateCatalystWarning(); // Initial load
    if (continuationCheckbox && continuationWrapper) {
      const toggleContinuation = () => {
        continuationWrapper.style.display = continuationCheckbox.checked ? '' : 'none';
        rerender();
      };
      continuationCheckbox.addEventListener('change', toggleContinuation, { passive: true });
      toggleContinuation(); // set initial state
    }

    if (areaInput) { areaInput.addEventListener('input', rerender, { passive: true }); areaInput.addEventListener('change', rerender, { passive: true }); }
    if (colorSelect) { colorSelect.addEventListener('change', rerender, { passive: true }); }
    if (meshOptOutEl) { meshOptOutEl.addEventListener('change', rerender, { passive: true }); }
    ['depth-', 'overage-', 'catalyst-', 'vubavert-', 'vubamac-', 'multi-color-toggle-'].forEach(prefix => {
      formEl.querySelectorAll(`input[type="radio"][name^="${prefix}"]`).forEach(r => r.addEventListener('change', rerender, { passive: true }));
    });

    // if (ctaBtn) {
    //   ctaBtn.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     addToCartFromForm(formEl, ctaBtn);
    //   });
    // }
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('#calculator-email-quote');
      if (!btn) return;

      const formEl = btn.closest('.coverage-calculator__form');
      if (!formEl) return;

      emailQuoteFromForm(formEl);
    });

    rerender();
  }

  function showLoading(mount) {
    mount.innerHTML = `
    <div class="cc-loading flex items-center gap-3 p-3 rounded-xl border border-gray-200">
      <span class="cc-spinner" aria-hidden="true"></span>
      <span>Calculating…</span>
    </div>
  `;
  }

  function initAll() {
    document.querySelectorAll('.coverage-calculator__form').forEach(initOneForm);
  }

  function emailQuoteFromForm(formEl) {
    const state = computeState(formEl);
    const unit = selectedVal(formEl, 'unit-') || 'm2';

    const displayArea = unit === 'sqft' ? (state.area * 10.7639) : state.area;

    if (!(state.area > 0)) {
      alert('Please enter a valid area.');
      return;
    }

    if (!state.colorHandle) {
      alert('Please choose a color.');
      return;
    }

    let lines = [];

    lines.push(`Area: ${displayArea.toFixed(2)} ${unit}`);
    lines.push(`Depth: ${selectedRadioLabel(formEl, 'depth-')}`);
    lines.push(`Color: ${state.colorDatum?.title || state.colorHandle}`);
    lines.push(`Resin: ${selectedRadioLabel(formEl, 'resin-')}`);
    lines.push(`Wastage: ${(state.wastePc * 100).toFixed(0)}%`);

    if (state.vmQty > 0) {
      lines.push(`VubaMac: ${state.vmQty} units`);
    }

    if (state.meshQty > 0) {
      lines.push(`Mesh rolls: ${state.meshQty}`);
    }

    if (state.catalyst === 'yes') {
      lines.push('Catalyst: Yes');
    }

    if (state.vubavert === 'yes') {
      lines.push('VubaVert: Yes');
    }

    if (state.continuationEnabled && state.continuationOrderNumber) {
      lines.push(`Continuation order: ${state.continuationOrderNumber}`);
    }

    const subject = encodeURIComponent('Vuba Stone – Coverage Calculator Quote');
    const body = encodeURIComponent(lines.join('\n'));

    window.location.href = `mailto:sales@vuba-stone.com?subject=${subject}&body=${body}`;
  }

  document.addEventListener('DOMContentLoaded', initAll, { passive: true });
  document.addEventListener('shopify:section:load', initAll, { passive: true });

  const css = `
  .coverage-calculator__form--results .coverage-calculator__product-list { margin-top:.75rem; }
  .coverage-calculator__form--results .cc-card { background:#fff; }
  .coverage-calculator__form--results .cc-errors { margin-bottom:.5rem; }
  .cc-spinner {
    display:inline-block; width:1rem; height:1rem; border-radius:9999px;
    border:2px solid #fff; border-right-color:transparent; animation: cc-spin .6s linear infinite;
  }
  @keyframes cc-spin { to { transform: rotate(360deg); } }
  @media (prefers-color-scheme: dark) {
    .coverage-calculator__form--results .cc-card { border-color:#3f3f46; background:#18181b; }
    .cc-spinner { border-color:#fff; border-right-color:transparent; }
  }
`;
  const style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);
})();